/**
 * EpisodeOfCare schemas — episode creation, status transitions.
 *
 * Enum arrays are tied to fhir-model types via `satisfies`.
 */
import { z } from 'zod';
import type {
  EpisodeOfCareStatus as FhirEocStatus,
} from '@unify/fhir-model/resources/episode-of-care';

/** FHIR EpisodeOfCare.status values (Unify subset). */
export const episodeOfCareStatusValues = [
  'planned',
  'active',
  'onhold',
  'finished',
  'cancelled',
] as const satisfies readonly FhirEocStatus[];

/**
 * Create EpisodeOfCare — from NewEpisodeOfCareModal + serviceRequestService.
 */
export const createEpisodeOfCareSchema = z.object({
  patientId: z.string().min(1, 'Patient is required'),
  status: z.enum(episodeOfCareStatusValues).default('planned'),
  therapyTypeCode: z.string().min(1, 'Episode type is required'),
  startDate: z.string().min(1, 'Start date is required'),
  careManagerId: z.string().optional(),
  managingOrganizationId: z.string().optional(),
});

export type CreateEpisodeOfCareInput = z.infer<typeof createEpisodeOfCareSchema>;
